import DocumentAuthModule from '@features/Consular/components/document-authentication/DocumentAuth.Module';

const DocumentAuth = () => {
  return <DocumentAuthModule />;
};

export default DocumentAuth;
